import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {formValueSelector} from "redux-form/immutable";
import {connect} from "react-redux";
import Form from "./ProductSurchargeForm";
import {GET_ADD_PRODUCT_SURCHARGE} from "../../../queries/sales";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {cancelApplyProductSurcharge} from "../../../actions/InventoryApiActions";
import {fromJS, Map, List} from "immutable";
import {validatePresence, validateGreaterThan} from "../../../lib/Validators";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";
import {hasStateProvince} from "../../../lib/AddressRules";
import {isUS, isCanada} from "../../../lib/CountriesAndStates";

function transformSurcharges(values) {
  let surcharge = values.get("surcharge", Map()).reduce((acc, val, key) => {
    return acc.push({
      currency: key,
      value: val
    })
  }, List());
  return values.set("surcharge", surcharge);  
}

function transformStateCode(values) {
  if (isUS(values.get("countryCode"))) return values;
  if (isCanada(values.get("countryCode"))) return values;
  return values.set("stateCode", "");
}

function transformInput(values) {
  let newValues = transformSurcharges(values)
  return transformStateCode(newValues)
}

class ApplyProductSurchargeFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    // The data has to be translated to be sent out.
    let transValues = transformInput(values)
                          .set("shopId", this.props.shopId)
                          .set("productSku", this.props.productId);
    return this.props.applyProductSurchargeForLocation(transValues.toJS())
      .then((response) => {
        if (response.data.applyProductSurchargeForLocation.errors.length <= 0) {
          this.props.cancelApplyProductSurcharge();
        } else {
          let errors = createValidationErrors(response.data.applyProductSurchargeForLocation.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelApplyProductSurcharge();
  }

  validateForm(values) {
    let errors = Map();
    errors = validatePresence(errors, values, "countryCode");
    let currencyErrors = values.get("surcharge", Map()).reduce((acc, value, currency) => {
      return validateGreaterThan(acc, values.get("surcharge", Map()), currency, 0);
    }, Map());
    // Merge into errors when present.
    if (currencyErrors.size > 0) {
      errors = errors.set("surcharge", currencyErrors);
    }
    return errors.toJS();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    const shopLocations = fromJS(data.shopLocations);
    let countries = shopLocations.filter(x => x.get("kind") === "country")
                                 .map(x => Map({countryCode: x.get("code"), countryName: x.get("name")}));
    let stateProvinces = List([]);
    if (this.props.showUSStates) stateProvinces = shopLocations.filter(x => x.get("kind") === "us-state");
    if (this.props.showCanadaProvinces) stateProvinces = shopLocations.filter(x => x.get("kind") === "ca-province");
    let shop = fromJS(data.shop);

    return (
      <Form
        currencies={shop.get("currencies")}
        errors={this.state.errors}
        countries={countries}
        stateProvinces={stateProvinces}
        showStateProvince={this.props.showStateProvince}
        validate={this.validateForm.bind(this)}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const APPLY_PRODUCT_SURCHARGE = gql`
  mutation applyProductSurchargeForLocation($data: ProductSurchargeInput!) {
    applyProductSurchargeForLocation(input: $data) {
      errors { key message }
    }
  }
`;

const withProductQuery = compose(
  graphql(GET_ADD_PRODUCT_SURCHARGE, {
    options: (props) => ({
      variables: {
        shopId: props.shopId
      }
    })
  }),
  graphql(APPLY_PRODUCT_SURCHARGE, {
    props: ({ mutate }) => ({
      applyProductSurchargeForLocation: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

const ApplyProductSurchargeFormContainerWithData = withProductQuery(ApplyProductSurchargeFormContainer);

const selector = formValueSelector("ProductSurchargeForm");
function mapStateToProps(state, ownProps) {
  return {
    showUSStates: isUS(selector(state, "countryCode")),
    showCanadaProvinces: isCanada(selector(state, "countryCode")),
    showStateProvince: hasStateProvince(selector(state, "countryCode"))
  }
}


export default connect(mapStateToProps, {cancelApplyProductSurcharge})(ApplyProductSurchargeFormContainerWithData);